document.addEventListener("DOMContentLoaded", function () {
    const checkboxes = document.querySelectorAll(".child__checkbox--wrapper");
    const innerWrappers = document.querySelectorAll(".child__inner--wrapper");

    checkboxes.forEach((checkboxWrapper) => {
        checkboxWrapper.addEventListener("click", function (e) {
            e.stopPropagation(); // Stop the click from bubbling up

            const checkbox = this.querySelector(".child__checkbox");
            const index = this.getAttribute("data-index");

            // If already active, remove active and show everything
            if (checkbox.classList.contains("checkbox__active")) {
                checkbox.classList.remove("checkbox__active");
                showAll();
            } else {
                // Remove active from all checkboxes
                document.querySelectorAll(".child__checkbox").forEach(cb => cb.classList.remove("checkbox__active"));

                // Add active to the clicked one
                checkbox.classList.add("checkbox__active");

                // Hide all inner wrappers
                innerWrappers.forEach(wrapper => {
                    wrapper.style.display = "none";
                });

                // Show only wrappers that match the clicked index
                innerWrappers.forEach(wrapper => {
                    if (wrapper.getAttribute("data-index") === index) {
                        wrapper.style.display = "block";
                    }
                });
            }
        });
    });

    function showAll() {
        innerWrappers.forEach(wrapper => {
            wrapper.style.display = "block";
        });
    }
});
